import { TelemetryGpsInfoEntity } from '@src/features/order/entities/telemetry_gps_info';

type SignalLostDrone = {
  connectionLost?: boolean;
  serialNumber?: string;
};

/** Gray map marker when link or GPS is lost for this drone. */
export function isDroneSignalLost(
  drone: SignalLostDrone | null | undefined,
  gpsInfo?: TelemetryGpsInfoEntity | null,
  flightSerial?: string | null,
): boolean {
  if (!drone) return false;
  if (drone.connectionLost) return true;

  return Boolean(
    gpsInfo?.gps_status?.gpsLost &&
      flightSerial &&
      drone.serialNumber === flightSerial,
  );
}
